import React, { useEffect } from 'react'
import { Button, Typography, CircularProgress } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { WhatsAppStatus } from './WhatsAppStatus';

import { getStatus, onBoard, onBoardRetry } from '../../services/whatsApp';

const FACEBOOK_CONFIG_ID = process.env.REACT_APP_FACEBOOK_CONFIG_ID
const REACT_APP_FACEBOOK_SOLUTION_ID = "1618419442200385"

export const WhatsAppConnect = (props) => {
  const [open] = React.useState(true);
  const [waitingOnFacebook, setWaitingOnFacebook] = React.useState(false)
  // status - success, error, warning, info
  const [state, setState] = React.useState(null)
  /*
    connectWaba: 'SUCCESS',
    subAccount: 'INPROGRESS',
    phoneAssignment: 'PENDING',
    whatsAppSender: 'PENDING',
    whatsAppTemplates: 'PENDING',
    done: false // simple flag that indicates if the onboarding is done
  */

  const decline = (event, reason) => {
    // we don't want users to accidentally close this popup due to clicking on backdrop if they're part way through
    if (reason === 'backdropClick') {
      return
    }

    props.onClose(false)
  }

  const retry = () => {
    onBoardRetry({ organizationId: props.organizationId })
      .then(res => {
        console.log('onBoardRetry.then', res)
      })
      .catch(err => {
        console.error('onBoardRetry.catch', err)
      })
  }

  useEffect(() => {
    let intervalId;

    getStatus(props.organizationId)
      .then(res => {
        console.log('getStatus.then', res)
        setState(res.data.status)
      })

    intervalId = setInterval(() => {
      getStatus(props.organizationId)
        .then(res => {
          console.log('getStatus.then', res)
          setState(res.data.status)

          // If the onboarding is done, clear the interval
          if (res?.data?.status?.done) {
            clearInterval(intervalId)
          }
        })
    }, 10000) // poll every 10 seconds

    console.log('WhatsAppConnect.mount.setInterval', intervalId)

    return () => {
      // Clear the interval right before component unmount
      console.log('WhatsAppConnect.unmount.clearInterval', intervalId)
      clearInterval(intervalId)
    }
  }, [props.organizationId])

  // Define session handler
  const embeddedSignupInfoListener = async (event) => {
    console.log('embeddedSignupInfoListener', event)
    // ignore non-relevant messages
    if (!event.origin.endsWith("facebook.com")) return

    try {
      const data = JSON.parse(event.data);
      console.log('embeddedSignupInfoListener', data)
      if (data.type === "WA_EMBEDDED_SIGNUP") {
        console.log('WA_EMBEDDED_SIGNUP', data)
        // if user finishes the Embedded Signup flow and the popup window closes
        if (data.event === "FINISH"|| data.event === "FINISH_ONLY_WABA") {
          const { phone_number_id, waba_id } = data.data;
          console.log({ phone_number_id, waba_id })
          // For now, you do not need to do anything here. Once App Review has been completed, then you
          // will pass the WABA ID to your backend service to use the Twilio Senders API to register the WhatsApp Sender.
          // Note that Meta only returns their phone_number_id, not the full phone number. Make sure to collect the
          // full phone number in your own user interface before the user clicks on this button.

          console.log('CALLING ONBOARD API', waba_id)
          onBoard({ waba_id })
            .then(result => {
              console.log('onBoard.then', result)
              setWaitingOnFacebook(false)
            })
        }
        else {
          // Otherwise the user canceled the Embedded Signup flow by closing the popup window before the last step.
          // We recommend you show an error to the user here.
          const { current_step } = data.data;
          console.log(`User did not finish ESU. Last step: ${current_step}`)
        }
      }
    } catch {
      return
    }
  }

  const connect = () => {
    // Listen for Embedded Signup events
    window.addEventListener("message", embeddedSignupInfoListener)

    // When the user navigates away from the page, remove the event listener
    window.addEventListener ("beforeunload" , () => 
        window.removeEventListener ("message", embeddedSignupInfoListener)
    )

    window.FB.login((response) => {
      console.log('FB.login.response', response)
      // const waba_id = 448054201733926
      let { waba_id = null, authResponse = null } = response

      if (!waba_id && authResponse) {
        waba_id = authResponse.waba_id
      }
    }, {
      config_id: FACEBOOK_CONFIG_ID,
      auth_type: 'rerequest',
      response_type: 'code',
      override_default_response_type: true,
      extras: {
        sessionInfoVersion: 3, // Required to get WABA ID
        featureType: 'only_waba_sharing', // to not prompt customers to provide a phone number as we will get Twilio to assign one and do the OTP verification automatically
        setup: {
          /*
            Once you add the Solution ID, you should notice that when you go through Embedded Signup,
            it displays that your company is working with Twilio to enable your customers on WhatsApp
            during the pop-up window flow. This is required by Meta's legal team, and cannot be removed.
          */
          // TODO: Add your Solution ID here
          solutionID: REACT_APP_FACEBOOK_SOLUTION_ID
        }
      }
    })

    setWaitingOnFacebook(true)
  }

  const stateFailed = () => {
    return Object.values(state).filter(s => s === 'FAIL').length > 0
  }

  return (
    <div>
      <Dialog
        maxWidth={state ? 'lg' : 'sm'}
        open={open}
        onClose={decline}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {
            !state && !waitingOnFacebook ? (`Looks like you haven't connected your WhatsApp Business account yet.`) : null
          }
          {
            state ? (`WhatsApp Status`) : null
          }
          {
            waitingOnFacebook ? (`Waiting on Facebook`) : null
          }
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            <strong>Follow .</strong>
          </DialogContentText> */}
          {
            !state && !waitingOnFacebook ? (
              <DialogContentText>
                In order to be able to use WhatsApp you must first connect your WhatsApp Business account to authorize sending messages on your behalf.
              </DialogContentText>
            ) : null
          }

          {
            state ? (
              <WhatsAppStatus status={state} />
            ) : null
          }

          {
            waitingOnFacebook ? (
              <DialogContentText>
                <Typography variant="h4" gutterBottom>We're waiting on Facebook's response.</Typography>
                <CircularProgress color="secondary" style={{marginBottom: '2em', alignSelf: 'center', justifySelf: 'center', display: 'flex'}} />
                <Typography variant="body1" gutterBottom>You should see a popup to login to Facebook. Once you've connected your WhatsApp Business account, we'll be able to proceed with the onboarding process.</Typography>
              </DialogContentText>
            ) : null
          }
        </DialogContent>
          
        <DialogActions>
          <Button onClick={decline} color="primary">
            Cancel
          </Button>
          {/* <Button onClick={agree} color="primary" autoFocus>
            Confirm Delete
          </Button> */}
          {
            !state ? (
              <button
                disabled={waitingOnFacebook}
                onClick={connect}
                style={{
                  backgroundColor: waitingOnFacebook ? '#b9d6fb' : '#1877f2',
                  border: '0',
                  borderRadius: '4px',
                  color: '#fff',
                  cursor: waitingOnFacebook ? 'default' : 'pointer',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  height: '40px',
                  padding: '0 24px'
                }}>
                Login with Facebook
              </button>
            ) : null
          }
          { state && !state.done && stateFailed() ? (<Button onClick={() => retry()} variant="outlined">Try Again</Button>) : null }
        </DialogActions>
      </Dialog>
    </div>
  );
}